import React from 'react'
import { humanizedWeeksAndDays } from './helpers'
import './TrimesterGraphics.scss'

const generateDivs = (labels, divsToColor, untilViability, isFetalTone) => {
  const arr = []

  for (let i = 1; i <= labels.length; i += 1) {
    let fillClass = ''

    // a fully-filled div
    if (i <= divsToColor) {
      fillClass = 'percent_100 filled'

      // until-viability specific logic
      if (untilViability) {
        if (labels.length === 9 && i === divsToColor) fillClass += ' purple'
        if (labels.length === 36 && i > divsToColor - 2) fillClass += ' purple'

        // and a bounding box
        if (labels.length === 36 && i === divsToColor - 1)
          fillClass += ' indicator partial'
        if (labels.length === 36 && i === divsToColor)
          fillClass += ' indicator lastbit'
      }

      // fetal tone specific logic
      if (isFetalTone) {
        if (labels.length === 36 && i > 5) fillClass += ' purple'
        if (labels.length === 36 && i === 6) fillClass += ' indicator partial'
        if (labels.length === 36 && i === 7) fillClass += ' indicator lastbit'
      }

      // a partially-filled div
    } else if (i < divsToColor + 1) {
      let fillPercent = divsToColor % 1 // get the decimal portion of the weeks to color
      fillPercent = Math.floor(fillPercent * 100) // convert that to a two-digit number
      fillClass = `percent_${fillPercent} filled`

      // until-viability graphic has purple trimester
      if (untilViability) fillClass += ' purple'
      if (isFetalTone) fillClass = 'fetal filled'

      // the div after the last filled one gets a little line down to the tooltip
    } else if (i === divsToColor + 1 && labels.length === 36) {
      fillClass += ' indicator'

      if (untilViability || isFetalTone) fillClass += ' partial'
    }

    arr.push(
      <div className={fillClass} key={`${labels[i - 1]}-${i - 1}`}>
        {' '}
        {labels[i - 1]}{' '}
      </div>
    )
  }
  return arr
}

const TrimesterGraphics = ({
  ageCap,
  galMode,
  clinicState,
  isMedical,
  isSurgical,
  medicalLimitKnown,
  surgicalLimitKnown,
  lexicon,
}) => {
  const isFetalTone = galMode === 'FETAL_TONE'
  const untilViability = ageCap === 'viability'

  let ageCapWeeks = Math.ceil(ageCap / 7)
  if (untilViability) {
    ageCapWeeks = 26
  }

  let positionClass = 'left'
  if (ageCapWeeks > 12) positionClass = 'center'
  if (ageCapWeeks > 24) positionClass = 'right'

  let tooltipLabel
  if (untilViability && !surgicalLimitKnown) {
    tooltipLabel = lexicon.get('available_through_viability_in_state', {
      state: clinicState,
    })
  } else if (untilViability) {
    tooltipLabel = lexicon.get('offered_through_viability')
  } else if (isMedical && !medicalLimitKnown) {
    tooltipLabel = lexicon.get('effective_through_weeks_only', {
      humanized_time: humanizedWeeksAndDays(ageCap, lexicon, true),
    })
  } else if (isSurgical && !surgicalLimitKnown) {
    tooltipLabel = lexicon.get('available_through_in_state', {
      humanized_time: humanizedWeeksAndDays(ageCap, lexicon),
      state: clinicState,
    })
  } else {
    tooltipLabel = lexicon.get('offered_through', {
      humanized_time: humanizedWeeksAndDays(ageCap, lexicon),
    })
  }

  if (isFetalTone) tooltipLabel = lexicon.get('fetal_tone')

  return (
    <div className={`TrimesterGraphics ${positionClass}`}>
      <div className="graph-and-labels">
        <div className="graph-container">
          <div className="trimester">
            {generateDivs(
              [
                lexicon.get('first'),
                lexicon.get('second'),
                lexicon.get('third'),
              ],
              ageCapWeeks / 12,
              untilViability,
              isFetalTone
            )}
          </div>
          <div className="month">
            {generateDivs(
              ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
              ageCapWeeks / 4,
              untilViability,
              isFetalTone
            )}
          </div>
          <div className="week">
            {generateDivs(
              Array(36).fill(''),
              ageCapWeeks,
              untilViability,
              isFetalTone
            )}
          </div>
        </div>

        <div className="labels-container">
          <div>{lexicon.get('trimester')}</div>
          <div>{lexicon.get('month')}</div>
          <div>{lexicon.get('week_label')}</div>
        </div>
      </div>

      <div className="tooltip-container">
        <div className="available-tooltip">{tooltipLabel}</div>
      </div>
    </div>
  )
}

export default TrimesterGraphics
